// Copyright (C) 2015 Minted Inc.
// All Rights Reserved
// CTAG:COMMUNITY:CHALLENGES

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
})(this, function (m_module, Backbone, $) {

  'use strict';

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};

  /**
   * @class M.Community.View.Challenge.AwardIcon Description: The award icons
   * attached to the designs in winners announced panel
   *
   */
  M.Community.View.Challenge.AwardIcon = Backbone.View.extend({

    template: {
      firstPlace: '<div class="firstPlaceIcon awardIcon">' +
        '<img class="sprite firstPlace" src="/static/images/sprite_placeholder.png"></div>',
      winner: '<div class="awardIcon">' +
        '<img class="sprite winner" src="/static/images/sprite_placeholder.png"></div>',
      editorsPick: '<div class="awardIcon">' +
        '<img class="sprite editorsPick" src="/static/images/sprite_placeholder.png"></div>',
      specialPrizeWinner: '<div class="specialPrizeWinnerIcon awardIcon">' +
        '<img class="sprite winner" src="/static/images/sprite_placeholder.png"></div>'
    },

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      var icon = $(this.template[this.options.type]);
      this.$el.html(icon);
      return this;
    }

  });

  return {};

});
